import React from 'react'

interface AuthLayoutProps {
  children: React.ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-trust-blue-50 to-white flex flex-col lg:flex-row">
      {/* Left side - Branding */}
      <div className="lg:w-1/2 flex flex-col justify-center items-center p-8 lg:p-12 bg-trust-blue text-white">
        <div className="max-w-md text-center lg:text-left">
          <div className="mb-8">
            <h1 className="text-4xl lg:text-5xl font-bold mb-4">
              Predictive<span className="text-intelligence-teal">MX</span>
            </h1>
            <p className="text-xl lg:text-2xl font-medium opacity-90">
              AI-Powered Predictive Maintenance
            </p>
          </div>
          
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="w-6 h-6 rounded-full bg-success-green flex items-center justify-center mt-1">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Prevent Equipment Failures</h3>
                <p className="text-sm opacity-75">Get alerts before problems become costly repairs</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="w-6 h-6 rounded-full bg-warning-amber flex items-center justify-center mt-1">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Optimize Maintenance</h3>
                <p className="text-sm opacity-75">Schedule maintenance at the perfect time</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="w-6 h-6 rounded-full bg-intelligence-teal flex items-center justify-center mt-1">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Save Money</h3>
                <p className="text-sm opacity-75">Reduce emergency repairs by up to 75%</p>
              </div>
            </div>
          </div>
          
          <div className="mt-12 p-6 bg-white/10 rounded-lg backdrop-blur-sm">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">$50,000+</div>
              <div className="text-sm opacity-75">Average annual savings per property</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Auth form */}
      <div className="lg:w-1/2 flex flex-col justify-center items-center p-8 lg:p-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8 lg:hidden">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Welcome Back</h2>
            <p className="text-gray-600">Sign in to your PredictiveMX account</p>
          </div>
          
          {children}
          
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Trusted by property managers worldwide
            </p>
            <div className="flex justify-center items-center space-x-6 mt-4 opacity-60">
              <div className="text-xs font-medium">SECURE</div>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <div className="text-xs font-medium">SOC2 COMPLIANT</div>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <div className="text-xs font-medium">99.9% UPTIME</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}